export const NEW_LIVE_CASINO_ARENA_NAME = 'newLiveCasino';
export const NEW_LIVE_CASINO_AB_ARENA_NAME = 'newLiveCasinoAB';
export const CIP_ALL_GAMES_ARENA_NAME = 'cipAllGames';
export const SLOTS_ARENA_NAME = 'slots';
export const CASINO_GAMES_ARENA_NAME = 'casinoGames';
export const JACKPOTS_ARENA_NAME = 'jackpots';
export const EXCLUSIVE_ARENA_NAME = 'exclusive888Games';
export const SCRATCH_CARDS_ARENA_NAME = 'scratchCards';
export const VIDEO_POKER_ARENA_NAME = 'videoPoker';
export const INSTANT_WIN_GAMES_ARENA_NAME = 'instantWinGames';
export const BLACKJACK_ARENA_NAME = 'blackjack';
export const VIRTUAL_SPORT_ARENA_NAME = 'virtualSport';
export const ROULETTE_ARENA_NAME = 'roulette';
export const PROGRESSIVE_SLOTS_ARENA_NAME = 'progressiveSlots';
export const NEW_GAMES_ARENA_NAME = 'newGames';
export const HOME_PAGE_ARENA = 'homePage';
export const VIDEO_SLIDES_ARENA = 'videoSlidesArena';

export const ALL_ARENAS = Array.of(
    NEW_LIVE_CASINO_ARENA_NAME,
    NEW_LIVE_CASINO_AB_ARENA_NAME,
    CIP_ALL_GAMES_ARENA_NAME,
    SLOTS_ARENA_NAME,
    CASINO_GAMES_ARENA_NAME,
    JACKPOTS_ARENA_NAME,
    EXCLUSIVE_ARENA_NAME,
    SCRATCH_CARDS_ARENA_NAME,
    VIDEO_POKER_ARENA_NAME,
    INSTANT_WIN_GAMES_ARENA_NAME,
    BLACKJACK_ARENA_NAME,
    VIRTUAL_SPORT_ARENA_NAME,
    ROULETTE_ARENA_NAME,
    PROGRESSIVE_SLOTS_ARENA_NAME,
    NEW_GAMES_ARENA_NAME,
    HOME_PAGE_ARENA,
);
